<template>
    <v-layout row wrap>
        <v-flex xs10 offset-xs1 lg8 offset-lg2>
            <v-form ref="form" @submit.prevent="submit">
                <v-card class="pa-3" v-if="!loading">
                    <v-card-text>

                        <v-alert color="error" icon="error" value="true" class="mb-3" v-if="!form.isActive">
                            {{ $t('message.info.approverTypeInactive') }}
                        </v-alert>
                        <v-alert color="warning" icon="warning" value="true" class="mb-3" v-else-if="form.isInUse">
                            {{ $t('message.info.approverTypeInUse') }}
                        </v-alert>

                        <div class="subheading">{{ $t('title.approverType') }}</div>
                        <p v-html="$t('message.info.approverType')"></p>
                        <v-layout row>
                            <v-flex xs1>
                                <label class="form-label">{{ $t('label.name') }}*</label>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field :disabled="disabled" v-model="form.name" :rules="validation.text" :validate-on-blur="true" :counter="constants.LENGTH_TYPE_APPROVER_NAME" :maxlength="constants.LENGTH_TYPE_APPROVER_NAME"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <v-card-actions v-if="!disabled">
                        <v-btn :loading="saving" :disabled="removing" @click="save" color="primary">
                            {{ $t('label.save') }}
                        </v-btn>

                        <v-btn :disabled="saving" :loading="removing" @click="remove" color="error" v-if="!!form.id">
                            {{ form.isInUse ? $t('label.inactivate') : $t('label.remove') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card v-else>
                    <app-card-loader></app-card-loader>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import validation from '@/helpers/validation';

import CardLoader from '@/components/shared/CardLoader';
import ApproverType from '@/helpers/entities/ApproverType';

export default {
    data() {
        return {
            constants,
            validation,
            removing: false,
            saving: false,
            loading: true,

            form: ApproverType.build(),
        };
    },

    computed: {
        disabled() {
            return !this.$store.getters.isAdmin ||
                !this.form.isActive;
        },
    },

    components: {
        appCardLoader: CardLoader,
    },

    watch: {
        $route: 'fetch',
    },

    created() {
        this.fetch();
    },

    methods: {
        async fetch() {
            this.loading = true;

            if (!utilities.isEmptyOrZero(this.$route.params.id)) {
                await this.$store.dispatch('fetchApproverType', this.$route.params.id);
                this.form = ApproverType.toForm(this.$store.getters.approverType);
            }

            this.loading = false;
        },

        async remove() {
            this.removing = true;
            await this.$store.dispatch('removeApproverType', this.form);
            this.$router.push({ name: 'typeApproverIndex' });
        },

        async save() {
            if (!this.$refs.form.validate()) return;

            this.saving = true;
            await this.$store.dispatch('saveOrUpdateApproverType', ApproverType.toPayload(this.form));
            this.$router.push({ name: 'typeApproverIndex' });
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/components/types/approver/Edit.vue